import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './index.scss';

const NEW_LINE = 'NEW_LINE';
const NEW_PRODUCTS = 'NEW_PRODUCTS';

const CategoryBadge = ({ badge: { type, title }, isCard }) => {
    const badgesClassNames = classnames({
        [styles.CategoryBadge]: true,
        [styles.CategoryBadgeNewLine]: type === NEW_LINE,
        [styles.CategoryBadgeNewProducts]: type === NEW_PRODUCTS,
        [styles.Card]: isCard,
    });

    return <div className={badgesClassNames}>{title}</div>;
};

CategoryBadge.propTypes = {
    badge: PropTypes.shape({
        type: PropTypes.oneOf([NEW_LINE, NEW_PRODUCTS]).isRequired,
        title: PropTypes.string.isRequired,
    }).isRequired,
    isCard: PropTypes.bool,
};

export default CategoryBadge;
